import React from 'react';
import styles from './LoginVideo.module.scss';

const LoginVideo = ({
  src = 'src/videos/loginVideo.mp4',
  poster = '/images/login-poster.jpg',
}) => {
  return (
    <video
      className={styles.video}
      src={src}
      poster={poster}
      autoPlay
      muted
      loop
      playsInline
    />
  );
};

export default LoginVideo;
